class ContactForm extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector('form');

    this.form.addEventListener('focusout', e => {
      if (!e.target.required) return;

      if (!e.target.validity.valid) {
        e.target.classList.add('error');
      }
    });

    this.form.addEventListener('input', e => {
      if (e.target.validity.valid) {
        e.target.classList.remove('error');
      }

      e.target.classList.remove('indeterminate');
    });
  }
}

if (!customElements.get("contact-form")) {
  customElements.define("contact-form", ContactForm);
}
